import {ThemeOptions} from '@mui/material';

export const profileBaseTheme: ThemeOptions = {
    typography: {
        h1: {
            fontSize: 30,
            fontWeight: 600,
        },
    },
    shape: {
        borderRadius: 20,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
    },
};

export const noShadow: ThemeOptions = {
    shadows: [
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
    ],
};
